import css from 'styled-jsx/css';

const styles = css.global`#den-fraudes-boleto-verdadeiro {
  padding: 0 0 40px;
  position: relative;
  overflow: hidden;
} 

#den-fraudes-boleto-verdadeiro .ctn-home-24 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  position: relative;
  z-index: 2;
}

#den-fraudes-boleto-verdadeiro .boleto-verdadeiro-conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#den-fraudes-boleto-verdadeiro .boleto-verdadeiro-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin: 0 0 16px 0;
  width: 100%;
}

#den-fraudes-boleto-verdadeiro .boleto-verdadeiro-titulo b {
  font-weight: 800;
}

#den-fraudes-boleto-verdadeiro ol {
  padding-left: 20px;
  max-width: 642px;
}

#den-fraudes-boleto-verdadeiro ol li {
  color: #222;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 8px;
}

#den-fraudes-boleto-verdadeiro .img-boleto-falso-1 {
  margin-top: 16px;
  width: 100%;
  max-width: 563px;
}

#den-fraudes-boleto-verdadeiro .img-boleto {
  position: absolute;
  bottom: -230px;
  width: 450px;
  right: -50px;
}

@media (min-width: 992px) {
  #den-fraudes-boleto-verdadeiro {
    padding: 45px 0 95px;
  } 
  #den-fraudes-boleto-verdadeiro .ctn-home-24 {
    flex-direction: row;
    justify-content: space-between;
  }
  #den-fraudes-boleto-verdadeiro .boleto-verdadeiro-titulo {
    margin: 0 0 18px 0;
  }

  #den-fraudes-boleto-verdadeiro .img-boleto-falso-1 {
    margin-top: 39px;
  }

  #den-fraudes-boleto-verdadeiro .img-boleto {
    bottom: -528px;
    width: auto;
    right: 0;
  }
}`;

export default styles;